var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"faqs"},_vm._l((_vm.faqs),function(faq,i){return _c('Index',{key:i,attrs:{"faq":faq,"index":i,"open":faq.open},on:{"toggleOpen":_vm.toggleOpen}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }